// Shared avatar helper, so the client SPA's account menu and the admin's
// account avatar apply the exact same rule: a person
// always gets the same 1-2 initials and the same avatar tint. Colour
// values themselves stay per-app (each app maps the returned index to its
// own CSS classes/tokens) — only the deterministic logic is shared here.

export const AVATAR_COLOR_COUNT = 6

/** Deterministic 0..N-1 bucket from a seed string (stable per person). */
export const avatarColorIndex = (seed: string): number => {
  let hash = 0
  for (let index = 0; index < seed.length; index++) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0
  }
  return hash % AVATAR_COLOR_COUNT
}

/** 1–2 uppercase initials from the name; falls back to "?" when unknown. */
export const getInitials = (firstname: string, lastname: string): string => {
  const first = firstname.trim()
  const last = lastname.trim()
  if (first === '' && last === '') return '?'
  if (last === '') return first.slice(0, 2).toUpperCase()
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
}
